import React, { useState, useEffect } from 'react';
import './ProgressiveImage.css';

// In-memory cache for image load promises
const imagePromiseCache = {};

function getScaledSrc(src) {
  if (!src || typeof src !== 'string') return src;
  // Only rewrite if src is under /images/
  if (src.startsWith('/images/')) {
    // Remove extension and use .jpg
    const base = src.substring(8).replace(/\.[^/.]+$/, '');
    return `/scaled/${base}.jpg`;
  }
  return src;
}

const ProgressiveImage = ({
  src,
  alt,
  className = '',
  placeholderSrc,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // Automatically generate placeholderSrc if not provided, ensuring src is a string
  const autoPlaceholderSrc = placeholderSrc || (src && typeof src === 'string' ? src.replace('/images/', '/thumbs/') : null);
  const scaledSrc = getScaledSrc(src);

  useEffect(() => {
    let isMounted = true;
    if (scaledSrc && typeof scaledSrc === 'string') {
      if (imagePromiseCache[scaledSrc]) {
        imagePromiseCache[scaledSrc].then(() => {
          if (isMounted) setIsLoaded(true);
        });
      } else {
        imagePromiseCache[scaledSrc] = new Promise((resolve, reject) => {
          const img = new window.Image();
          img.src = scaledSrc;
          img.onload = () => {
            resolve();
          };
          img.onerror = reject;
        });
        imagePromiseCache[scaledSrc].then(() => {
          if (isMounted) setIsLoaded(true);
        });
      }
    } else {
      setIsLoaded(false);
    }
    return () => { isMounted = false; };
  }, [scaledSrc]);

  return (
    <img
      src={isLoaded ? scaledSrc : autoPlaceholderSrc}
      alt={alt}
      className={className}
    />
  );
};

export default ProgressiveImage; 